export const CLOSE_ADD_SIDE_MODAL = "CLOSE_ADD_SIDE_MODAL";
export const OPEN_ADD_SIDE_MODAL = "OPEN_ADD_SIDE_MODAL";
